enum TableSettings {
	desc = 'desc',
	asc = 'asc',
	tableSettings = 'tableSettings',
}

export default TableSettings;
